import {
  Button,
  Form,
  Modal,
  RadioInput,
  Title,
  useForm,
  useToast,
} from "@validereinc/common-components";
import { Forms } from "@validereinc/domain-controllers";
import { toTitleCaseString } from "@validereinc/utilities";
import PropTypes from "prop-types";
import React, { useState } from "react";

const { FormSubmissionStatusOptions } = Forms.logic;

const UpdateStatusModal = ({
  open,
  onClose,
  doUpdate,
  onUpdate,
  entityTitle,
  currentStatus,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { toast } = useToast();
  const form = useForm({
    defaultValues: {
      status: currentStatus,
    },
  });

  const handleOnClose = () => {
    form.reset({
      status: currentStatus,
    });
    onClose();
  };

  const handleOnSubmit = async ({ status }) => {
    try {
      setIsSubmitting(true);
      await doUpdate({ status });

      toast.push({
        intent: "success",
        description: `${entityTitle} status changed to ${toTitleCaseString(
          status,
          { intent: "ui" }
        )}`,
      });

      if (onUpdate) {
        onUpdate();
      }

      setIsSubmitting(false);
      onClose();
    } catch (err) {
      setIsSubmitting(false);
      toast.push({
        intent: "error",
        description: `Unable to update status of ${entityTitle}.`,
      });
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleOnClose}
    >
      <Modal.Header>
        <Title>Update Status</Title>
      </Modal.Header>
      <Form
        {...form}
        onSubmit={handleOnSubmit}
      >
        <Modal.Body>
          <RadioInput
            label="Select a status"
            name="status"
            isRequired
            labelKey="label"
            valueKey="value"
            options={FormSubmissionStatusOptions}
          />
        </Modal.Body>
        <Modal.Footer className="clearfix modal-footer">
          <Button onClick={handleOnClose}>Cancel</Button>
          <Button
            type="submit"
            variant="primary"
            disabled={isSubmitting}
          >
            Update Status
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

UpdateStatusModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  doUpdate: PropTypes.func.isRequired,
  onUpdate: PropTypes.func,
  entityTitle: PropTypes.string.isRequired,
  currentStatus: PropTypes.string,
};

export default UpdateStatusModal;
